module.exports = __webpack_public_path__ + "img/ban_13.8fd10ce8.png";